import * as Yup from 'yup';
import { EsFileState } from '@enums';

export function useValidationSchema() {
  return Yup.object().shape({
    state: Yup.mixed<EsFileState>().nullable().required(),
  }) as Yup.Schema<{ state: EsFileState }>;
}
